import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageLoaderService } from "lib/ng2-sapmp/src/ui-components/page-loader";
import { AuthenticationService } from "lib/ng2-sapmp/src/providers/authentication.service";
import { HeaderService } from '../header/header.service';


@Component({
  selector: 'app-multi-stubid-page',
  templateUrl: './multi-stubid-page.component.html',
  styleUrls: ['./multi-stubid-page.component.scss']
})
export class MultiStubidPageComponent implements OnInit {
  multiStubId_flag: boolean;
  listOfStubIds: any;
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(private router: Router, private pageloaderService: PageLoaderService,
     private authenticationService: AuthenticationService, private headerService: HeaderService) {
    this.listOfStubIds = localStorage.getItem('dmp_stubid_list') ? JSON.parse(localStorage.getItem('dmp_stubid_list')) : [];
  }

  ngOnInit(): void {
   if(location.href.indexOf("selectstubid") != -1)  {
    this.multiStubId_flag = true;
   }  else {
    this.multiStubId_flag = false;
   }
   this.pageloaderService.setPageLoaderStatus(true);
  }
  
  stubId: any;
  selectedStubId: any;

  onSelectStubId(stubId: any): void {
    this.selectedStubId = stubId;
    // this.selectedStubId = '';
    localStorage.setItem('dmpStubId', this.selectedStubId);
    // this.router.navigate(['authentication']);
    this.authenticationService.validateUser()
        .subscribe(
          (resp: any) => {
              this.authenticationService.navigateAfterLogin(null);
          },
          error => this.authenticationService.handleLoginError(error.status),
  )
  }
}
